/* eslint-disable @typescript-eslint/no-explicit-any */
export default function Container(props: { children: any }) {
  return (
    <div className='bg-gray-50 w-full h-full px-8 md:px-12 lg:px-24 xl:px-48 2xl:px-96 py-6 lg:py-12 text-black leading-normal tracking-wider'>
      {props.children}
    </div>
  )
}
